import React, {useState} from 'react';
import {useTranslation} from 'react-i18next';
import PropTypes from 'prop-types';
import {Collapse} from 'react-collapse';
import {Alert, Space} from 'antd';
import {StyledModalWithIcon, StyledModalWithIconDescription, StyledModalWithIconTitle} from './StyledModalWithIcon';

const defaultError = {
  message: null,
  open: false
};

const ModalWithIcon = ({
  contentDescription,
  contentTitle,
  handleOk,
  handleCancel,
  icon,
  loading = false,
  open,
  ...rest
}) => {
  const [t] = useTranslation(['main', 'expenses']);
  const [error, setError] = useState(defaultError);

  const trans = (key) => t(`expenses:modal.approveExpense.${key}`);

  const handleAfterClose = () => {
    if (error.open) setError(defaultError);
  }

  const handleSubmit = () => {
    if (handleOk) {
      handleOk?.({
        errorCallback: (response) => {
          const message = response?.data?.message;
          if (message) {
            setError({ ...error, message, open: true });
          }
        }
      });
    }
  }

  return (
    <StyledModalWithIcon
      afterClose={handleAfterClose}
      cancelButtonProps={{size: 'middle'}}
      forceRender
      loading={loading}
      okButtonProps={{
        disabled: loading,
        size: 'middle',
        type: 'primary',
      }}
      okText={t('confirm')}
      onCancel={handleCancel}
      onOk={handleSubmit}
      open={open}
      title={trans('title')}
      width={400}
      {...rest}
    >
      <Space size='small' direction='vertical' align='center'>
        {icon && <StyledModalWithIconDescription>{icon}</StyledModalWithIconDescription>}
        {contentTitle && <StyledModalWithIconTitle>{contentTitle}</StyledModalWithIconTitle>}
        {contentDescription && <StyledModalWithIconDescription>{contentDescription}</StyledModalWithIconDescription>}
      </Space>
      <Collapse isOpened={error.open}>
        <Alert message={error.message} type='error' showIcon />
      </Collapse>
    </StyledModalWithIcon>
  );
}

ModalWithIcon.propTypes = {
  contentDescription: PropTypes.string,
  contentTitle: PropTypes.string,
  handleCancel: PropTypes.func,
  handleOk: PropTypes.func,
  icon: PropTypes.any,
  loading: PropTypes.bool,
  open: PropTypes.bool.isRequired,
}

export default ModalWithIcon;
